﻿// JScript File
/*****************************************************************************************************************************************/
/*
/*  Formating routines
/*
/**/
/*
/// С#-like formating function.
///   usage : "{0} ... {1} ... {2}".format(1,2,3);
String.prototype.format = function()
{
var xx = this;
for(var i=0;i<arguments.length;i++)
{
xx = xx.replace("{"+i+"}", arguments[i]);
}
return xx;
}
*/
/// С#-like formating function.
///   usage : "{0} ... {1} ... {2}".format(1,2,3);

String.prototype.format = function() {
    var xx = this + "";
    var rex = /\{(\d+):?(.*?)\}/igm;

    var callback = function(expr, index, format) {
        index = parseInt(index);
        if (isNaN(index)) return expr;
        var val = callback.context;
        if ((!val) || (val.length <= index)) return expr;

        val = val[index];

        if ((format) && (val != null) && (val != undefined) && (val.toStringEx)) return val.toStringEx(format);

        return val || val === 0 ? val.toString() : "";
    };

    callback.context = arguments;
    return xx.replace(rex, callback);
}

String.prototype.numberFromCurrencyFormat = function () {
    var currencyCodeStripped = this.replace(/[^0-9-.]/g, '');

    var number = parseFloat(currencyCodeStripped);

    if (isNaN(number)) {
        return parseFloat(this.replace(/[^\d\.]+/ig, ""));
    }

    return number;
};

String.prototype.currencyCodeFromCurrencyFormat = function () {
    var numberPartStripped = this.replace(/(\d+(,\d{3,3}|)(\.\d{2,}|))/g, '');

    return numberPartStripped;
};

String.prototype.toCurrencyFormat = function (number, currencySign) {

    var roundedNumber = parseFloat(number).roundForCurrencyFormat();
    var value = NumberFormat.format(roundedNumber);
    return this.format(value , currencySign);
}

String.prototype.toCurrencyLocalizedFormat = function (number, currencySign) {

    var roundedNumber = parseFloat(number).roundForCurrencyFormat();
    var value = DefaultNumberFormat.format(roundedNumber);
    return this.format(value , currencySign);
}

Number.prototype.roundForCurrencyFormat = function() {
    return (Math.floor((this.toFixed(5) * 1000).toPrecision(16)) / 1000).toFixed(2);
}

/// Formating function for Numbers.
///    Can take formats:
///       G - general
///       E and En - Exponential (with n digints in second case)
///       And custom format with marked digit places 0 (for obligatory digints)  or # (for possible digits)
Number.prototype.toStringEx = function (format)
{

    var sign = null;
    // scientific formats
    if (format == "G") return this.toString();
    if (format == "E") return this.toExponential();
    if (format.match(/E(\d+)/)) return this.toExponential(parseInt(RegExp.$1));
    if (format.match(/S(.+)/))
    {
        sign = this > 0 ? "+" : "";
        var zformat = RegExp.$1;
        if (zformat.indexOf(".") < 0) return sign + this.toStringEx(zformat);

        var zzz = format.split(".");
        var ddl = 1;
        for (var i = 0; i < zzz[1].length; i++) ddl *= 10;

        return sign + (Math.floor(this * ddl) / ddl).toStringEx(zformat);
    }

    // custom format : with 0 and #
    rformat = "";  // round part of format
    fformat = "";  //

    if (format.indexOf(".") > 0)
    {
        var zzz = format.split(".");
        rformat = zzz[0];
        fformat = zzz[1];
        zzz = null;
    }
    else if (format.indexOf(",") > 0)
    {
        var zzz = format.split(",");
        sign = ",";
        rformat = zzz[0];
        fformat = zzz[1];
        zzz = null;
    }
    else
    {
        rformat = format;
        fformat = "";
    }

    if (fformat.match(/0+#+/))
    {
        var ll = fformat.match(/(0+)/)[0].length;
        var zz = this.toStringEx(rformat + "." + fformat.replace("#", "0"));

        var splitter = zz.match(new RegExp("\\.(\\d{" + ll + "})(\\d+)$"));
        var new_part = splitter[1] + splitter[2].replace(/0+$/, "");

        return zz.replace(/\d+$/, new_part);
    }

    if (rformat.match(/0+/) && fformat.match(/0+#+/))
    {

        var ll = fformat.match(/(0+)/)[0].length;
        var zz = this.toFixed(fformat.length);
        var splitter = zz.match(new RegExp("\\.(\\d{" + ll + "})(\\d+)$"));
        var new_part = splitter[1] + splitter[2].replace(/0+$/, "");
        return zz.replace(/\d+$/, new_part);
    }

    if(rformat.match(/#+ #+0+/))
    {
        var formattedString = this.toLocaleString("cs");
        //if this is integer we have to add as much 0, as the formatter matches
        if (fformat.match(/0+/) && this != 0 && this % 1 === 0)
        {
            formattedString = formattedString + "," + Array(fformat.length + 1).join("0");
        }
        //if this have one number after the decimal separator, we have to add one less 0
        else if (fformat.match(/0+/) && this != 0 && (fformat.length > 1) && ((this * 10) % 1 === 0))
        {
            formattedString = formattedString + Array(fformat.length).join("0");
        }
        return formattedString;
    }

    if (rformat.match(/#+/) && fformat.match(/0+/))
    {
        return this.toFixed(fformat.length);
    }

    if (rformat.match(/#+/) && fformat.match(/#*/))
    {
        return this.toFixed(fformat.length).replace(/0+$/, "").replace(/\.$/, "");
    }

    if (rformat.match(/0+/) && fformat.match(/0+/))
    {
        var zz = this.toFixed(fformat.length);
        while (zz.length < rformat.length + fformat.length + (fformat ? 1 : 0)) zz = "0" + zz;
        return zz;
    }

    if (rformat.match(/0+/) && fformat.match(/#*/))
    {
        var pow = Math.pow(10, fformat.length);
        // When multyplying * pow sometimes we get values that are like 13215.9999999999997 and after Math.floor we are loosing precision,
        // so using roundToDigit for more accurate precision
        // var zz = ((Math.floor(this.multiply(pow))).divide(pow)).toFixed(fformat.length);
        var zz = this.roundToDigit(fformat.length).toFixed(fformat.length);
        while (zz.length < rformat.length + fformat.length + (fformat ? 1 : 0)) zz = "0" + zz;
        if (fformat)
            return zz.replace(/0+$/, "").replace(/\.$/, "");
        else
            return zz;
    }

    throw "Bad format string";
}

/// Used to round digits more precisely after the decimal point
Number.prototype.roundToDigit = function (decimal)
{
    return Number(Math.round(this.valueOf() + 'e' + decimal) + 'e-' + decimal);
}

/// Date and time formating functions. Not all formats was realized
Date.prototype.toStringEx = function(format) {
    var val = this;
    var mm;
    var res = format;

    if (res.match(/Z/) || res.match(/UTC/)) {
        res = res.replace(/YYYY/i, this.getUTCFullYear().toStringEx("0000"));
        res = res.replace(/YY/i, (this.getUTCFullYear() % 100).toStringEx("00"));
        res = res.replace(/Y/i, this.getUTCFullYear() % 100);

        res = res.replace(/DD/i, (this.getUTCDate()).toStringEx("00"));
        res = res.replace(/D/i, this.getUTCDate());

        res = res.replace(/hh/, (this.getUTCHours() % 12).toStringEx("00"));
			
		if (res.match(/\st/)) {
			res = res.replace(/h/, this.getUTCHours() === 0 || this.getUTCHours() === 12 ? "12" : (this.getUTCHours() % 12).toString());
		}

		else {
			res = res.replace(/h/, this.getUTCHours() === 12 ? "12" : (this.getUTCHours() % 12).toString());
		}

        res = res.replace(/HH/, this.getUTCHours().toStringEx("00"));
        res = res.replace(/H/, this.getUTCHours());

        res = res.replace(/m{2,}/, this.getUTCMinutes().toStringEx("00"));
        res = res.replace(/m/, this.getUTCMinutes());


        res = res.replace(/K+/, (this.getTimezoneOffset() < 0 ? "+" : "-") + (Math.abs(this.getTimezoneOffset()) / 60).toFixed() + (Math.abs(this.getTimezoneOffset()) % 60).toStringEx("00"));

        res = res.replace(/Z+/, "UTC");

        res = res.replace(/s{2,}/, this.getSeconds().toStringEx("00"));
        res = res.replace(/s/, this.getSeconds());

        res = res.replace(/MMMM/, function($0, $1) { return $string("Month")[val.getUTCMonth() + 1]; });
        res = res.replace(/MMM/, function ($0, $1) { return $string("Month")[val.getUTCMonth() + 1].slice(0, 3); });
        res = res.replace(/MM/, (this.getUTCMonth() + 1).toStringEx("00"));
        //    res = res.replace(/M/, this.getUTCMonth()+1);
    }
    else {

        res = res.replace(/YYYY/i, this.getFullYear().toStringEx("0000"));
        res = res.replace(/YY/i, (this.getYear() % 100).toStringEx("00"));
        res = res.replace(/Y/i, (this.getYear() % 100));

        res = res.replace(/dd/, (this.getDate()).toStringEx("00"));
        res = res.replace(/d/, this.getDate());

        res = res.replace(/K+/, (this.getTimezoneOffset() < 0 ? "+" : "-") + (Math.abs(this.getTimezoneOffset()) / 60).toFixed() + (Math.abs(this.getTimezoneOffset()) % 60).toStringEx("00"));

        res = res.replace(/hh/, this.getHours() == 12 ? "12" : (this.getHours() % 12).toStringEx("00"));
			
		if (res.match(/\st/)) {
			res = res.replace(/h/, this.getHours() === 0 || this.getHours() === 12 ? "12" : (this.getHours() % 12).toString());
		}

		else {
			res = res.replace(/h/, this.getHours() === 12 ? "12" : (this.getHours() % 12).toString());
		}

        res = res.replace(/HH/, this.getHours().toStringEx("00"));
        res = res.replace(/H+/, this.getHours());

        res = res.replace(/m{2,}/, this.getMinutes().toStringEx("00"));
        res = res.replace(/m/, this.getMinutes());

        res = res.replace(/s{2,}/, this.getSeconds().toStringEx("00"));
        res = res.replace(/s/, this.getSeconds());

        res = res.replace(/MMMM/, function ($0, $1) { return $string("Month")[val.getMonth() + 1]; });
        res = res.replace(/MMM/, function ($0, $1) { return $string("Month")[val.getMonth() + 1].slice(0, 3); });
        res = res.replace(/MM/, (this.getMonth() + 1).toStringEx("00"));
        //    res = res.replace(/M/, this.getMonth()+1);

    }

    res = res.replace(/ff(f+)/, this.getMilliseconds().toStringEx("000"));
    res = res.replace(/ff/, this.getMilliseconds().toStringEx("00"));
    //  res = res.replace(/f/, this.getMilliseconds().toStringEx("0"));

    res = res.replace(/\st/, this.getHours() < 12 ? " AM" : " PM");

    res = res.replace(/DDDD/, $string('DayNames')[val.getDay()]);
    res = res.replace(/DD/, $string('ShortDayNames')[val.getDay()]);

    return res;
}

/*****************************************************************************************************************************************/
/*
/*  Server constants routines
/*
/**/

/// Internal hashtables for loaded constants
var __sectionsHash = new Object();

/// Adds translations for specified section into cache
/// string section - section name
/// JSON values - key/value pairs
function $initStrings(section, values)
{
    for (var propertyName in values)
    {
        if (values.hasOwnProperty(propertyName))
        {
            values[propertyName] = $unescapeHTML(values[propertyName]);
        }
    }
    __sectionsHash[section] = values;
}

/// Returns section of translated string constants
///    string section - section name
function $string(section) {
    if (arguments.length == 1) {
        var scs = __sectionsHash[section];
        if (scs) return scs;

        scs = __loadStringSection(section);
        if (scs) return __sectionsHash[section] = scs;

        return null;
    }
    else {
        // if more than one argument is supplied, the function doesn't return anything,
        // but loads the requested sections into the __sectionsHash

        var nonCachedSections = Array.filter(arguments,
                                            function (name) { return !__sectionsHash[name] })
                                     .join(',');
        if (nonCachedSections)
        {
            __loadStringSectionList(nonCachedSections);
        }
    }
}

/// Returns section of non translated numeric constants
///    string section - section name
function $int(section) {
    scs = $string(section);

    if (!scs.$int) {
        __setNumbers(scs);
    }

    return scs;
}

//--------------------------------  SERVICE FUNCTIONS --------------------------------------------------------------

/// Object clonning
function __cloneObject(obj) {
    res = {};
    for (key in obj) {
        res[key] = obj[key];
    }
    return res;
}

/// Trying to convert each massive element to number
function __setNumbers(obj) {
    for (key in obj) {
        var zz = new Number(obj[key]);
        if (!isNaN(zz)) obj[key] = zz;
    }

    obj.$int = true;
}

/// Loading the section from server
///   string sectionName - name of section in xml file
function __loadStringSection(sectionName) {
    var data = __blockingAJAXCall("/Constants.ashx?section={0}&lock={1}".format(sectionName, (new Date()).getTime()));
    if (data.status != 200) return null;

    var lines = data.text.split("\r\n");
    if (lines.length == 0) return null;

    var res = new Object;                         // resulting object
    var splitter = /^(\w+?)=(.*)/;              // precompiled regex for parsing data if format key=value

    for (var i = 0; i < lines.length; i++) {
        var line = lines[i];
        var splitIdx = line.indexOf("=");

        if (splitIdx < 0) continue;

        var key = line.substr(0, splitIdx);
        var val = line.substr(splitIdx + 1, line.length - splitIdx - 1);

        res[key] = val;
    }

    res.$int = false;
    return res;
}

/// Loading the section from server
///   string sectionName - name of section in xml file
function __loadStringSectionList(sections) {
    if (typeof isLngDomainChanged != "undefined") {
        if (isLngDomainChanged == 1 && window.location.href.indexOf("www") != -1 && Cookies.get("lng") != 4) {
            Cookies.remove("lng");
        }
    }

    var data = __blockingAJAXCall("/Constants.ashx?section={0}&lock={1}".format(sections, (new Date()).getTime()));
    if (data.status != 200) return;

    var lines = data.text.split("\r\n");
    if (lines.length == 0) return;

    var current_section = null;

    for (var i = 0; i < lines.length; i++) {
        var line = lines[i];

        if (line.indexOf("@@@@@") == 0) {
            current_section = {};
            var name = line.substr(5, line.length - 5);
            __sectionsHash[name] = current_section;
            continue;
        }

        if (!current_section) continue;

        var line = lines[i];
        var splitIdx = line.indexOf("=");

        if (splitIdx < 0) continue;

        var key = line.substr(0, splitIdx);
        var val = line.substr(splitIdx + 1, line.length - splitIdx - 1);

        current_section[key] = val;
    }
}

/// Performs blocking ajax call to the url. Returns object like { bool status, string statusText,  string text }
///    URL      - URL of script to call
///    isPost   - [optional] is this post request
///    postbody - [optional] body for post request (XmlDocument or string)
function __blockingAJAXCall(URL, isPost, postbody) {
    var xmlHttp = __createXmlHttp();

    xmlHttp.open((isPost) ? "POST" : "GET", application_root + URL, false);
    xmlHttp.setRequestHeader("RequestTarget", "XmlService");

    if ((isPost) && (postbody))
        xmlHttp.send(postbody);
    else
        xmlHttp.send(null);

    var Status = xmlHttp.status;
    if (Status != 200) {
        return { status: Status, statusText: xmlHttp.statusText, text: xmlHttp.responseText };
    }

    return { status: 200, statusText: 'OK', text: xmlHttp.responseText };
}

/****************************************************************************************************************************************
/*
/*  Date formating functions
/*
/**/

/// Decoding time from ISO string representation
Date.fromISO = function(ms) {
    //2008-05-12T15:28:45.6642211+03:00 - example of server answer
    if (ms == null) return;
    arr = ms.match(/(\d+)-(\d+)-(\d+)T(\d+):(\d+):(\d+)\.?(\d*)/i);
    if (!arr) return undefined;

    return new Date(
    parseInt(arr[1], 10),
    parseInt(arr[2], 10) - 1,
    parseInt(arr[3], 10),
    parseInt(arr[4], 10),
    parseInt(arr[5], 10),
    parseInt(arr[6], 10),
    arr[7] ? parseFloat("0." + arr[7]) * 1000 : 0
  );
}

/// Decoding time from ISO string representation and applying timezone shift
Date.UTCFromISO = function(ms) {
    //2008-05-12T15:28:45.6642211+03:00 - example of server answer
    if (ms.match(/Z\s*$/i)) return Date.fromISO(ms);

    var pre = Date.fromISO(ms);

    arr = ms.match(/([+-])(\d+):(\d+)\s*$/i);
    if (!arr) return undefined;

    var delta = (parseInt(arr[2]) * 60 + parseInt(arr[3])) * (arr[1] == "+" ? -1 : +1);
    pre.setMinutes(pre.getMinutes() + delta);
    return pre;
}

/****************************************************************************************************************************************
/*
/*  String formating functions
/*
/**/
String.prototype.toStringEx = function (format)
{
    return this;
}

String.prototype.toLocalizedNumberString = function ()
{
    if (isNaN(this) || this.length == 0)
    {
        return "";
    }
    else
    {
        return DefaultNumberFormat.format(this);
    }
}

String.prototype.startsWith = String.prototype.startsWith || function (searchString, position)
{
    var position = position || 0;

    return this.substr(position, searchString.length) === searchString;
}

String.prototype.endsWith = String.prototype.endsWith || function (searchString, position)
{
    var subjectString = this.toString();
    if (typeof position !== 'number' || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length)
    {
        position = subjectString.length;
    }
    position -= searchString.length;
    var lastIndex = subjectString.lastIndexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};

function $dict(constant)
{
    return (PageConstants && (constant in PageConstants))
             ? PageConstants[constant]
             : constant;
}

function $createBlockDictById(id)
{
    var dict = Configuration.Dictionary[id];

    return $createBlockDict(dict);
}

function $createBlockDict(dict)
{
    var constants = dict;

    return function(constant)
    {
        return (constants && (constant in constants))
            ? constants[constant]
            : constant;
    };
}

/* exported $escapeHTML */
var $escapeHTML = (function ()
{
    var cache = { 'null': '', 'undefined': '', '': '' },
        map = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', '\'': '&#39;' },
        mapFunc = function(c) { return map[c]; };

    /*jshint maxcomplexity: 6*/
    return function(str) {
        if (str === 0 || (str && !str.replace)) {
            return str;
        }
        if (cache.hasOwnProperty(str)) {
            return cache[str] !== null ? cache[str] : str;
        }

        var result = str.replace(/[&<>'"]/g, mapFunc);
        cache[str] = result !== str ? result : null;

        return result;
    };
}());

/* exported $escapeHTML */
var $unescapeHTML = (function ()
{
    var map = { '&amp;': '&', '&lt;': '<', '&gt;': '>', '&quot;': '"' },
        mapFunc = function (c) { return map[c]; };

    /*jshint maxcomplexity: 6*/
    return function (str)
    {
        if (str === 0 || (str && !str.replace))
        {
            return str;
        }

        var result = str.replace(/&amp;|&lt;|&gt;|&quot;/g, mapFunc);

        return result;
    };
}());

// Fix for IE8 and other legacy browsers missing String.trim() function
if (typeof (String.prototype.trim) !== "function")
{
    String.prototype.trim = function ()
    {
        return this.replace(/^\s+|\s+$/g, '');
    }
}

String.prototype.trimText = function(charCount)
{
	var endingSymbols = '...';

	if (typeof charCount !== 'number' || this.length <= charCount + endingSymbols.length)
	{
		return this.toString();
	}

	return this.substring(0,charCount - endingSymbols.length) + endingSymbols;
}

window.__sectionsHash = __sectionsHash;
window.$initStrings = $initStrings;
window.$string = $string;
window.$int = $int;
window.__cloneObject = __cloneObject;
window.__setNumbers = __setNumbers;
window.__loadStringSection = __loadStringSection;
window.__loadStringSectionList = __loadStringSectionList;
window.__blockingAJAXCall = __blockingAJAXCall;
window.$dict = $dict;
window.$createBlockDict = $createBlockDict;
window.$createBlockDictById = $createBlockDictById;
window.$escapeHTML = $escapeHTML;
window.$unescapeHTML = $unescapeHTML;



